'use strict';
import React, { PureComponent } from 'react'
import CabeceraAsientoContable from './CabeceraAsientoContable';
import RegistroAsientoContable from './RegistroAsientoContable';

class SeccionGrilla extends PureComponent {
    constructor(props) {
        super(props);
        this.validarAplicarAccionMasiva = this.validarAplicarAccionMasiva.bind(this);
    }

    async validarAplicarAccionMasiva(esBaja) {
        const {mostrarOcultarModalAsientosContables, validarAplicarAccionMasiva, seleccionarOpcionCombo, cambiarCheckAsientosContables, setearOrigenLlamadoModalConfirmacionBaja} = this.props;
    
        if (esBaja) { // Si es dar de baja abrir modal
            setearOrigenLlamadoModalConfirmacionBaja("accionMasiva")
            mostrarOcultarModalAsientosContables("modalConfirmarBajaAsientos", true);
        } else {

            await validarAplicarAccionMasiva(); 
            // Al aplicar la accion masiva, se espera a que finalice para resetear los checks seleccionados y el valor del combo de acción
            cambiarCheckAsientosContables("checkTodosAsientosContables", false);
            seleccionarOpcionCombo("comboAccionMasiva", 0, false);
        }
    }
    

    render() {
        const {
            modelosContablesSeleccionados,
            checksAsientosContables,
            comboAccionMasiva,
            estadosAsientos,
            arrayResultadoBusquedaAsientos,
            registroDesplegado,
            permisosUsuario,
            checkTodosAsientosContables,
            currentScope
        } = this.props;

        //ACTIONS
        const {
            desplegarDatosAdicionales,
            mostrarOcultarModalAsientosContables,
            seleccionarOpcionCombo,
            cambiarCheckAsientosContables,
            cambiarCheckRegistroResultadoBusqueda,
            obtenerDatosDetalleAsiento,
            cargarInformacionReproceso,
            mostrarOcultarSpinner
        } = this.props;
        
        const registrosArray = [];
        arrayResultadoBusquedaAsientos.map((reg, index) => {
            let esPar = (index + 1) % 2 == 0;

            registrosArray.push(<RegistroAsientoContable
                desplegarDatosAdicionales={desplegarDatosAdicionales}
                mostrarOcultarModalAsientosContables={mostrarOcultarModalAsientosContables}
                modelosContablesSeleccionados={modelosContablesSeleccionados}
                obtenerDatosDetalleAsiento={obtenerDatosDetalleAsiento}
                cargarInformacionReproceso={cargarInformacionReproceso}
                mostrarOcultarSpinner={mostrarOcultarSpinner}
                key={reg.AsientocabeceraId}
                registro={reg}
                esPar={esPar}
                registroDesplegado={registroDesplegado}
                seleccionarOpcionCombo={seleccionarOpcionCombo}
                comboAccionMasiva={comboAccionMasiva}
                estadosAsientos={estadosAsientos}
                checksAsientosContables={checksAsientosContables}
                checkTodosAsientosContables={checkTodosAsientosContables}
                cambiarCheckAsientosContables={cambiarCheckAsientosContables}
                cambiarCheckRegistroResultadoBusqueda={cambiarCheckRegistroResultadoBusqueda}
                currentScope={currentScope}
            />);
        });

        let esNinguna = comboAccionMasiva == 0;
        let esBaja = comboAccionMasiva == 3;
        let mensaje = <div></div>
        let contador = arrayResultadoBusquedaAsientos.filter(item => item.EstaTildado).length;
        let cantidadRenglones = arrayResultadoBusquedaAsientos.length;
        let deshabilitarBotonAplicar = esNinguna || contador == 0;


        if(contador > 1){
            switch (comboAccionMasiva) {
                case "1":
                    mensaje = <div>Se confirmarán {contador} asientos</div>
                    break;
                case "2":
                    mensaje = <div>Se desconfirmarán {contador} asientos</div>
                    break;
                case "3":
                    mensaje = <div>Se darán de baja {contador} asientos</div>
                    break;
                default:
                    mensaje = <div></div>
                    break;
                }
        }

        if(contador == 1){
            switch (comboAccionMasiva) {
                case "1":
                    mensaje = <span>Se confirmará {contador} asiento</span>
                    break;
                case "2":
                    mensaje = <span>Se desconfirmará {contador} asiento</span>
                    break;
                case "3":
                    mensaje = <span>Se dará de baja {contador} asiento</span>
                    break;
                default:
                    mensaje = <span></span>
                    break;
                }
        } 

        if(contador == 0){
            switch (comboAccionMasiva) {
                case "1":
                    mensaje = <span>Por favor elija al menos 1 asiento</span>
                    break;
                case "2":
                    mensaje = <span>Por favor elija al menos 1 asiento</span>
                    break;
                case "3":
                    mensaje = <span>Por favor elija al menos 1 asiento</span>
                    break;
                default:
                    mensaje = <span></span>
                    break;
                }
        }

        return (
            <div className="AsientosContables__contenedorGrilla">
                <div className="seccionRenglonesModelo__contenedorInfoGeneralBotones__cantidadRenglones AsientosContables--floatNone"> {`Cantidad de registros: ${cantidadRenglones}`}</div>

                <div className="AsientosContables__contenedorGrillaSeccionSuperior">
                    <div className="seccionDatosGenerales__tituloSecundario">Acción Masiva</div>

                    <div className="AsientosContables__contenedorGrillaSeccionSuperior__SelectBotones">
                        <div className="AsientosContables--floatLeft">
                            <select 
                                name="accionMasivaSelect" 
                                className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect AsientosContables--noMargin AsientosContables__contenedorGrillaAccionMasivaSelect"
                                onChange={(event) => seleccionarOpcionCombo("comboAccionMasiva", event.target.value, false)}
                                value={comboAccionMasiva}>
                                    <option value="0">Ninguna</option>
                                {permisosUsuario.Confirmacion &&
                                    <option value="1">Confirmar</option>
                                }
                                {permisosUsuario.Confirmacion &&
                                    <option value="2">Desconfirmar</option>
                                }
                                {permisosUsuario.Baja &&
                                    <option value="3">Dar de baja</option>
                                }
                            </select>
                        </div>

                        <div className={"AsientosContables--floatLeft" + (deshabilitarBotonAplicar ? " AsientosContables__botonVerFiltros--deshabilitado" : "")}>
                            <button className={deshabilitarBotonAplicar ? "seccionSuperior__botonNuevo seccionSuperior__botonNuevo--deshabilitado" : "seccionSuperior__botonNuevo "} disabled={deshabilitarBotonAplicar} onClick={() => !deshabilitarBotonAplicar && this.validarAplicarAccionMasiva(esBaja)}>
                                Aplicar
                            </button>
                        </div>
                        <div className="AsientosContables--floatLeft AsientosContables_Mensaje_AccionMasiva">
                            {mensaje}
                        </div>

                        <div className="seccionRenglonesModelo__contenedorInfoGeneralBotones__botonExcel AsientosContables--floatRight" onClick={() => mostrarOcultarModalAsientosContables("modalConfirmarDetalleAsiento", true)}></div>
                    </div>
                </div>

                <CabeceraAsientoContable
                    modelosContablesSeleccionados={modelosContablesSeleccionados}
                    comboAccionMasiva={comboAccionMasiva}
                    cambiarCheckAsientosContables={cambiarCheckAsientosContables}
                    checkTodosAsientosContables={checkTodosAsientosContables}
                />
        <div className="modalLogIntentosScroll AsientosContables__scrollGrilla">
                    {registrosArray.length === 0 && this.props.primeraConsultaRealizada ? ( // Verificar si se ha realizado la primera consulta
                        <div className="seccionGrilla__registro--SinResultados">
                            No se encontraron resultados
                        </div>
                    ) : (
                        registrosArray
                    )}
                </div>
            </div>
        );
    }
}

export default SeccionGrilla;